<template>
  <div class="mp-input-number-wrapper mp-flex">
    <div
      class="mp-icon mp-flex-center"
      :class="{ disabled: value <= min }"
      @mousedown="down"
      @mouseup="stop"
      @mouseleave="stop"
    >
      <minus />
    </div>
    <a-input-number
      ref="antInputNumber"
      v-bind="$attrs"
      :value="value"
      :min="min"
      :max="max"
      @change="e => $emit('change', e)"
    ></a-input-number>
    <div
      class="mp-icon mp-flex-center"
      :class="{ disabled: value >= max }"
      @mousedown="up"
      @mouseup="stop"
      @mouseleave="stop"
    >
      <plus />
    </div>
  </div>
</template>

<script>
import { Minus, Plus } from '@icon-park/vue'

export default {
  components: {
    Minus,
    Plus
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      required: true
    },
    min: {
      type: Number,
      default: -Infinity
    },
    max: {
      type: Number,
      default: Infinity
    }
  },
  methods: {
    down() {
      this.$refs.antInputNumber.$children[0].down()
    },
    up() {
      this.$refs.antInputNumber.$children[0].up()
    },
    stop() {
      this.$refs.antInputNumber.$children[0].stop()
    }
  }
}
</script>

<style lang="less" scoped>
.mp-input-number-wrapper {
  border: 1px solid #e4e8f2;
  border-radius: 4px;
  user-select: none;

  .mp-icon {
    width: 30px;
    height: 100%;
    cursor: pointer;
    font-size: 14px;

    &.disabled {
      color: #c9c8ce;
      cursor: not-allowed;
    }
  }

  // 覆盖ant默认样式
  ::v-deep .ant-input-number {
    border-radius: 0;
    border: none;
    font-weight: 500;
    font-size: 16px;
    border-left: 1px solid #e4e8f2;
    border-right: 1px solid #e4e8f2;

    &-handler-wrap {
      display: none;
    }
    &-input {
      text-align: center;
    }
    &-input-wrap {
      margin-top: 1px;
    }

    &-focused,
    &:focus {
      box-shadow: none;
    }
  }
}
</style>
